import type { FC, PropsWithChildren } from 'react';

import { ScLootboxButton } from './styled';

interface LootboxButtonProps {
  handleClick?: () => void;
}

export const LootboxButton: FC<PropsWithChildren<LootboxButtonProps>> = ({
  children,
  handleClick,
}) => <ScLootboxButton onClick={handleClick}>{children}</ScLootboxButton>;
